export default {
  no_data: 'There are no background operations',
  reanalyze: 'Reanalyze is in progress',
  running_operation: 'Running operation',
  clear_all: 'Clear all'
};
